export default "__VITE_ASSET__TDw6ty87__"